/** Catalog's part of "Download my data": the caller's files here. */
export const myDataApi = '/catalog/v1/me/data'
